type Params = {
  pagination: {
    page: number;
    perPage: number;
  };
  filter: {
    [x: string]: any;
  };
  target?: string;
  [x: string]: any;
};

const withLocalFilters = (controller: (resource: string, params: Params) => Promise<any>) => {
  return async (resource: string, params: Params) => {
    return controller(resource, params);
  };
};

export default withLocalFilters;
